import React from "react";
import { MyDayStock } from "../../components/analytics";
const Day = () => {
  return (
    <div className="bg-darkMode-background min-h-screen w-full relative p-4">
      <MyDayStock big={true} />
    </div>
  );
};

export default Day;
